import { Component } from 'preact';
import PropTypes from "prop-types";
import { combineClasses } from "@green24/npm-javascript-utils";
import { locationPartnerServices } from "../../../services/location-services";
import ErrorBlock from "../../../components/shared/ErrorBlock";
import Loading from "../../../components/shared/Loading";
import ButtonsConstructor from "../../../components/shared/Input/Button/ButtonsConstructor";
import BoxTerminal from "../../../components/shared/BoxTerminal";
import Interpret from "../../../components/shared/Localization/Interpret";
import withConfiguration from "../../../components/shared/hoc/withConfiguration";
import { TranslatedText } from "../../../components/components";
import { E_Keyboard_Type } from "../../../models/constants/Enums_Keyboard";
import MessageModal from "../../../components/shared/Modal/MessageModal";
import { route } from "preact-router";
import { E_Route } from "../../../models/constants/Enum_Routes";

class DeliveryWizardUser extends Component {
	constructor(props) {
		super();

		this.state = {
			loading: true,
			error: null,
			users: [],
			selectedUser: props.selectedUser,
			customUserEmail: props.customUserEmail,
		}
	}

	componentDidMount() {
		this._refresh();
	}

	_renderSelector() {
		const {configuration} = this.props;
		const {users, selectedUser, customUserEmail} = this.state;

		return <ButtonsConstructor buttons={[
			configuration.allowDeliveryManualUserEntry &&
			{
				text: (
					<span>
						<Interpret id={"selectUser.manualEntry"}/>

						<span className={"email"}>{customUserEmail}</span>
					</span>
				),
				className: "manual-entry-button",
				action: () => this._enterUserManually(),
				active: !!customUserEmail,
			},
			...(
				users?.map(user => {
					return {
						text: (
							<span>
								{
									user.name &&
									<span>{user.name}</span>
								}

								<span className={"email"}>{user.email}</span>
							</span>
						),
						textTranslated: true,
						active: user.id === selectedUser?.id,
						action: () => this.setState({
							selectedUser: user,
							customUserEmail: null,
						}),
					}
				}) ?? []
			)
		]}/>
	}

	_renderContent() {
		const {onContinue} = this.props;
		const {selectedUser, customUserEmail} = this.state;

		return (
			<>
				<BoxTerminal
					title={"box.deliverPackage"}
					contentSlot={
						<div className={"selector"}>
							{this._renderSelector()}
						</div>
					}
					contentHeaderSlot={
						<div className={"title"}>
							<Interpret id={"selectUser"}/>
						</div>
					}
				/>
				<nav class={"action-buttons"}>
					<ButtonsConstructor buttons={[
						{
							className: "confirm-button",
							text: "continue",
							action: () => onContinue(selectedUser, customUserEmail),
							disabled: !selectedUser && !customUserEmail,
						}
					]}/>
				</nav>
			</>
		)
	}

	render({className, style, onContinue}, {loading, error, users, selectedUser}) {
		return (
			<section className={combineClasses("delivery-wizard-user", className)} style={style}>
				{loading && <Loading block={true}/>}
				{error && <ErrorBlock error={error} onRetry={() => this._refresh()}/>}

				{
					!loading &&
					!error &&
					this._renderContent()
				}
			</section>
		);
	}

	_refresh() {
		const {locationID, partnerID, configuration, onContinue} = this.props;

		if(!partnerID) {
			if(!configuration.allowDeliveryManualUserEntry) {
				onContinue(null, null);
			}
			else{
				this.setState({loading: false});
			}

			return
		}

		this.setState({
			loading: true,
			error: null,
		});
		locationPartnerServices(locationID).getUsers(partnerID).then(users => {
			if(users.length === 0) {
				window.modal.open(
					<MessageModal
						title={"deliveryWizard.users.error.noUsers.title"}
						message={"deliveryWizard.users.error.noUsers.message"}
					/>,
					{
						onClosed: () => route(E_Route.BASE),
					}
				);
			}
			else {
				this.setState({users});
			}
		}, error => {
			this.setState({error});
		}).finally(() => {
			this.setState({loading: false});
		});
	}

	_enterUserManually() {
		const {customUserEmail} = this.state;
		window.keyboard.open(
			E_Keyboard_Type.EMAIL,
			customUserEmail,
			"emailAddress",
			value => this.setState({customUserEmail: value, selectedUser: null}),
			{
				maxLength: false,
			}
		)
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			locationID: PropTypes.number.isRequired,
			partnerID: PropTypes.number,
			selectedUser: PropTypes.object,

			onContinue: PropTypes.func.isRequired,

			//withConfiguration
			configuration: PropTypes.object.isRequired,
		}
	}

	static get stateTypes() {
		return {
			loading: PropTypes.bool,
			error: PropTypes.object,
			users: PropTypes.array,
			selectedUser: PropTypes.object,
			customUserEmail: PropTypes.string,
		}
	}
}

export default withConfiguration(DeliveryWizardUser);
